/**
 * SearchInput — Campo de busca com debounce, ícone e botão limpar
 */
import { useState, useEffect, useRef } from 'preact/hooks';
import { T } from '../../styles/tokens';

interface SearchInputProps {
  /** Placeholder do campo */
  placeholder?: string;
  /** Callback chamado após debounce (300ms) */
  onSearch: (value: string) => void;
  /** Valor inicial */
  defaultValue?: string;
  /** Tempo de debounce em ms */
  debounceMs?: number;
}

export function SearchInput({ placeholder = 'Buscar...', onSearch, defaultValue = '', debounceMs = 300 }: SearchInputProps) {
  const [value, setValue] = useState(defaultValue);
  const timerRef = useRef<any>(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onSearch(value), debounceMs);
    return () => clearTimeout(timerRef.current);
  }, [value, debounceMs]);

  return (
    <div style={{
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    }}>
      {/* Ícone de busca */}
      <span style={{
        position: 'absolute',
        left: T.space3,
        color: T.textMuted,
        fontSize: T.textMd,
        pointerEvents: 'none',
      }}>🔍</span>
      <input
        type="text"
        value={value}
        onInput={(e) => setValue((e.target as HTMLInputElement).value)}
        placeholder={placeholder}
        style={{
          width: '100%',
          padding: `${T.space2}px ${T.space10}px ${T.space2}px ${T.space10}px`,
          background: T.bgCard,
          border: `1px solid ${T.border}`,
          borderRadius: T.radiusMd,
          color: T.text,
          fontSize: T.textMd,
          outline: 'none',
          transition: `border-color ${T.transitionFast}`,
        }}
        onFocus={(e) => (e.currentTarget.style.borderColor = T.borderFocus)}
        onBlur={(e) => (e.currentTarget.style.borderColor = T.border)}
      />
      {/* Botão limpar */}
      {value && (
        <span
          onClick={() => setValue('')}
          style={{
            position: 'absolute',
            right: T.space3,
            color: T.textMuted,
            fontSize: T.textMd,
            cursor: 'pointer',
            lineHeight: 1,
          }}
        >✕</span>
      )}
    </div>
  );
}
